import axios from 'axios';
import { AGGREGATION_API_PATH, API_PATH } from '../constants/constants';

export const createApiClient = (useAltPath = false) => {
	const basePath = useAltPath ? AGGREGATION_API_PATH : API_PATH;
	return axios.create({
		baseURL: window.origin + basePath,
		headers: {
			'X-BFF-CSRF': 'true',
		},
	});
};

const apiClient = createApiClient();

apiClient.interceptors.response.use(
	response => {
		return response.data;
	},
	error => {
		if (error.response) {
			throw new Error(error.response.data.message || error.response.data.msg);
		} else if (error.request) {
			throw new Error('No response received');
		} else {
			throw new Error('Request setup error');
		}
	}
);

export default apiClient;
